import { UpdatePaymentScrapTradesApi } from "@/features/accounts/payment/scraping/services/update-trades-api";
import { UpdatePaymentScrapTradesPostRequestModel } from "@/features/accounts/payment/scraping/services/update-trades-model";

/// Look明細更新（サーバ版スクレイピング）処理
export class UpdatePaymentScrapTradesService {
  private updatePaymentScrapTradesApi = new UpdatePaymentScrapTradesApi();

  /**
   * Look明細更新（サーバ版スクレイピング）API実行
   */
  public async updatePaymentScrapTrades(param: UpdatePaymentScrapTradesPostRequestModel) {
    return await this.updatePaymentScrapTradesApi.updatePaymentScrapTrades(param);
  }
}
